import React from 'react';
import { twMerge } from 'tailwind-merge';

import { isMobile } from 'helpers/deviceCutoffs';

import Tokens from 'styles/tokens';

interface IAvomaPopoverProps
  extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  mobileFullWidth?: boolean;
  width?: number | string;
  style?: React.CSSProperties;
  wrapperStyle?: React.CSSProperties;
  position?: 'top' | 'bottom';
  isRightAlign?: boolean;
  className?: string;
  innerDivClassname?: string;
  radiumConfigContext?: unknown;
  styleKeeperContext?: unknown;
}

const styles = {
  dropdownWrapper: {
    ...Tokens.shadows.medium,
    position: 'absolute',
    backgroundColor: Tokens.colors.white,
    border: `1px solid ${Tokens.colors.gainsboro}`,
    borderRadius: '3px',
    zIndex: '9999'
  } satisfies React.CSSProperties,
  positionBottom: {
    marginTop: '6px'
  } satisfies React.CSSProperties,
  positionTop: {
    marginBottom: Tokens.spacing.one,
    bottom: Tokens.spacing.three
  } satisfies React.CSSProperties,
  dropdownInner: {
    padding: Tokens.spacing.two
  } satisfies React.CSSProperties
};

const NUMERIC_WIDTH_PATTERN = /^\d+(\.\d+)?$/;
const DEFAULT_WIDTH = 256;

const AvomaPopover = ({
  children,
  mobileFullWidth,
  width = DEFAULT_WIDTH,
  style,
  wrapperStyle,
  position = 'bottom',
  isRightAlign = false,
  className = '',
  innerDivClassname = '',
  radiumConfigContext: _radiumConfigContext,
  styleKeeperContext: _styleKeeperContext,
  ...otherProps
}: IAvomaPopoverProps) => {
  let resolvedWidth: string | number = width;

  if (isMobile() && mobileFullWidth) {
    resolvedWidth = '100vw';
  } else if (typeof width === 'number') {
    resolvedWidth = `${width}px`;
  } else if (
    typeof width === 'string' &&
    NUMERIC_WIDTH_PATTERN.test(width.trim())
  ) {
    resolvedWidth = `${width.trim()}px`;
  } else {
    resolvedWidth = width;
  }

  return (
    <div
      style={{
        ...styles.dropdownWrapper,
        ...(isRightAlign && { right: 0 }),
        ...(position === 'bottom' ? styles.positionBottom : styles.positionTop),
        width: resolvedWidth,
        ...wrapperStyle,
        ...(isMobile() && mobileFullWidth && { position: 'fixed' })
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...otherProps}
      className={twMerge('rounded', className)}
    >
      <div
        style={{
          ...styles.dropdownInner,
          ...style
        }}
        className={innerDivClassname}
      >
        {children}
      </div>
    </div>
  );
};

export default AvomaPopover;
